import React from 'react';
import {useSelector,useDispatch} from 'react-redux'
import {getDocByOrgnrPdf} from 'actions'
import {FormControl,RadioGroup,FormControlLabel,Radio,makeStyles} from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination';
const useStyles = makeStyles((theme) => ({
    Paggination: {
        display:"flex",
        justifyContent:"end"
    },
  }));
  //getDocByOrgnr(userid, Afid, Orgnr)
function BefintligaDoc(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const AuthUser = useSelector(state=>state.auth.authUser)
    const AntalDokPdf = useSelector(state=>state.accountsData.AntalDokPdf)
    const DocumentListPdf = useSelector(state=>state.accountsData.DocumentListPdf)
    console.log(AntalDokPdf,"AntalDokPdf")
    const [page,setPage] = React.useState(0)
    React.useEffect(()=>{
        dispatch(getDocByOrgnrPdf(AuthUser.user_id,AuthUser.user_Afid,props.EsigneringOrgnr,page,"",1))
    },[])
    const [value,setValue] = React.useState("")
    
    const handleChange = (e)=>{
        setValue(e.target.value)
        props.onChangeBefintlig(e.target.value)
    }
    const handleChangePage =  (event, newPage) => {
        setPage(newPage-1);
        dispatch(getDocByOrgnrPdf(AuthUser.user_id,AuthUser.user_Afid,props.EsigneringOrgnr,newPage-1,"",1))
    }
    React.useEffect(()=>{
        setValue(props.Value)
    },[props.Value])
    return (
        <div>
            <FormControl component="fieldset">
                <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange}>
                    {
                        DocumentListPdf
                        .map(item=>{
                            return <FormControlLabel 
                            value={item.Doc_Url}
                            control={<Radio />} 
                            label={item.Doc_Name}
                            />
                        })
                    }
                </RadioGroup>
            </FormControl>
            <div className={classes.Paggination}>
            <Pagination 
            count={Math.ceil(AntalDokPdf/5)} 
            page={page+1} onChange={handleChangePage}
            classes={classes.ul}
            size={"small"}
            showFirstButton showLastButton />
           </div>
        </div>
    );
}

export default BefintligaDoc;